import React, { createContext, useContext, ReactNode } from 'react';
import { useComprehensiveNutrition as useNutritionHook } from '@/hooks/useComprehensiveNutrition';

type NutritionContextType = ReturnType<typeof useNutritionHook>;

const NutritionContext = createContext<NutritionContextType | null>(null);

export const NutritionProvider = ({ children }: { children: ReactNode }) => {
  const nutritionData = useNutritionHook();
  
  return (
    <NutritionContext.Provider value={nutritionData}>
      {children}
    </NutritionContext.Provider>
  );
};

export const useComprehensiveNutrition = () => {
  const context = useContext(NutritionContext);
  if (!context) {
    throw new Error('useComprehensiveNutrition must be used within NutritionProvider');
  }
  return context;
};
